<div class="graph-container flex flex-col">
  <div
    class="graph-wrapper flex flex-row"
    [ngStyle]="{ 'max-height': graphHeight + 50 + 'px', flex: graphHeight + 50 + 'px' }"
  >
    <div [ngStyle]="{ 'max-height': graphHeight + 20 + 'px', flex: graphHeight + 20 + 'px' }">
      <svg
        data-at-graph
        class="graph"
        [class.no-edge-values]="!edgeValues"
        [attr.width]="graphWidth + 20 + 'px'"
        [attr.height]="graphHeight + 40 + 'px'"
      >
        <g *ngFor="let x of gridX" class="grid x-grid">
          <line [attr.x1]="x" [attr.x2]="x" [attr.y1]="0" [attr.y2]="graphHeight"></line>
        </g>
        <g *ngFor="let y of gridY" class="grid y-grid">
          <line [attr.x1]="0" [attr.x2]="graphWidth" [attr.y1]="y" [attr.y2]="y"></line>
        </g>
        <g class="axis x-axis-first">
          <ng-container *ngFor="let x of gridX; let id = index">
            <text *ngIf="isFirstX(id)" [attr.x]="x" [attr.y]="graphHeight + 28">
              {{ reverseFn(x) }}
            </text>
          </ng-container>
        </g>
        <g class="axis x-axis">
          <ng-container *ngFor="let x of gridX; let id = index">
            <text
              *ngIf="id !== 0 && id !== gridX.length - 1"
              [attr.x]="x"
              [attr.y]="graphHeight + 28"
            >
              {{ reverseFn(x) }}
            </text>
          </ng-container>
        </g>
        <g class="axis x-axis-last">
          <ng-container *ngFor="let x of gridX; let id = index">
            <text *ngIf="isLastX(id)" [attr.x]="x" [attr.y]="graphHeight + 28">
              {{ reverseFn(x) }}
            </text>
          </ng-container>
        </g>
        <polyline [attr.points]="points" />
        <g *ngFor="let v of renderedValues" class="circles">
          <circle [attr.cx]="v.x" [attr.cy]="v.y" [attr.r]="valueRadius" />
          <text
            data-at-circle-val-small
            *ngIf="v.value >= 100"
            class="circle-value smaller"
            [attr.x]="v.x - 12.5"
            [attr.y]="v.y + 5"
          >
            {{ v.viewValue }}
          </text>
          <text
            data-at-circle-val
            *ngIf="v.value < 100"
            class="circle-value"
            [attr.x]="v.x - 10"
            [attr.y]="v.y + 5"
          >
            {{ v.viewValue }}
          </text>
        </g>
        <g *ngIf="isFlowTemperatureAvailable">
          <polyline
            [matTooltip]="maxFlowTemperature + ' ' + unit"
            class="flow-temperature"
            [attr.points]="renderDottedRedLine()"
            fill="none"
            stroke="red"
            stroke-width="2"
            stroke-dasharray="10,8"
          ></polyline>
        </g>
      </svg>
    </div>
    <div
      data-at-label-y
      class="label label-y"
      [style.top.px]="(graphHeight + 50) / 2"
      [style.left.px]="edgeValues ? graphWidth - 44 : graphWidth - 60"
    >
      {{ labelY }}
    </div>
  </div>
  <div class="flex flex-row justify-start items-center flex-[40px] max-w-[40px]">
    <div
      data-at-label-x
      class="label label-x"
      [ngStyle]="{
        'max-width': graphWidth + 'px',
        'min-width': graphWidth + 'px',
        flex: graphWidth + 'px'
      }"
    >
      {{ labelX }}
    </div>
  </div>
  <div class="flex flex-row justify-end items-center mt-4" *ngIf="isFlowTemperatureAvailable">
    <svg width="30px" height="20px" viewBox="0 0 20 2" class="mr-2 p-2 border border-black-200">
      <polyline
        class="flow-temperature"
        [attr.points]="'0,1 20,1'"
        fill="none"
        stroke="red"
        stroke-width="2"
        stroke-dasharray="4,4"
      ></polyline>
    </svg>
    <div>{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.LABEL' | translate }}</div>
  </div>
</div>
